export default (theme) => ({
    container: {
        ...theme.softpro.safeBox,
        marginTop: 0,
    },
});
